// @view/authentication/PasswordResetCompleteForm.view.tsx

import React from "react";
import * as styles from "@styles/PasswordReset.css";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import * as Option from "@utils/Option";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { PasswordResetCompleteViewProps } from "@ps-bridge/contracts/passwordResetComplete";
import { onInputAction } from "@view/effects/inputHandlers";

type PasswordResetCompleteFormViewProps = Pick<
  PasswordResetCompleteViewProps,
  "password" | "confirmPassword" | "onPasswordChange" | "onConfirmPasswordChange" | "onSubmit"
>;

const PasswordResetCompleteFormView: React.FC<PasswordResetCompleteFormViewProps> = ({
  password,
  confirmPassword,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}) => {
  return (
    <>
      <div className={styles.field}>
        <Input
          type="password"
          placeholder="New password"
          value={Option.fold(password, () => "", (value) => value)}
          onChange={onInputAction(onPasswordChange)}
          autoComplete="new-password"
          data-testid="password-reset-complete-password"
        />
      </div>
      <div className={styles.field}>
        <Input
          type="password"
          placeholder="Confirm password"
          value={Option.fold(confirmPassword, () => "", (value) => value)}
          onChange={onInputAction(onConfirmPasswordChange)}
          autoComplete="new-password"
          data-testid="password-reset-complete-confirm-password"
        />
      </div>
      <Button
        className={styles.button}
        onClick={() => {
          IO.run(onSubmit(ok));
        }}
        asChild={Option.none()}
        data-testid="password-reset-complete-submit"
      >
        Set new password
      </Button>
    </>
  );
};

export default PasswordResetCompleteFormView;
